








import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class UiProgressBarComponent extends Vue {
  @Prop({
    default: 0
  })
  public percentage: number;

  @Prop({
    default: true
  })
  public animated: boolean;

  @Prop({
    default: ''
  })
  public title: string;
}
